var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-1xl"},[_c('router-link',{attrs:{"to":_vm.subItem.router}},[_c('the-language',{attrs:{"de":_vm.subItem.title_de,"en":_vm.subItem.title_en}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }